<template>
  <d-col xl="8" sm="12" cols="12">
    <h5>Prazo de entrega</h5>
    <table class="table table-bordered">
      <thead class="bg-light" role="rowgroup">
        <tr role="row">
          <th>Atividade</th>
          <th>Prazo</th>
          <th></th>
        </tr>
      </thead>
      <tbody role="rowgroup">
        <tr v-for="(row, navItemId) in model.deadlines" :key="navItemId">
          <td class="p-2 activity">
            <textarea class="form-control" v-model="row.activity" ></textarea>
          </td>
          <td class="p-2 description">
            <textarea class="form-control" v-model="row.description" ></textarea>
          </td>
          <td>
            <div class="buttons">
              <i class="fas fa-plus text-success" @click="addRow()" v-if="navItemId + 1 === model.deadlines.length"></i>
              <i class="fas fa-minus text-danger" @click="removeRow(navItemId)" ></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </d-col>
</template>

<script>
import { cloneDeep } from '_utils';
import { MODEL } from './QuotationModel';

export default {
  name: 'quotation-deadlines',
  props: {
    model: {
      type: Object,
      default: () => cloneDeep(MODEL),
    },
  },
  computed: {
  },
  methods: {
    addRow() {
      this.model.deadlines.push({ activity: '', description: '' });
    },
    removeRow(index) {
      this.model.deadlines.splice(index, 1);
      if (this.model.deadlines.length === 0) {
        this.addRow();
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
table {
  td {
    vertical-align: middle;
    text-align: center;
  }
  .activity {
    width: 30%;
  }
  .description {
    width: 70%;
  }
  .buttons {
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    height: 100%;
    .fa-minus {
      margin-left: 10px;
    }
    i {
      cursor: pointer;
    }
  }
}
</style>
